import Model from "./base/model";

class TransporterCustomOccurrence extends Model {
  resourceName() {
    return "transporter_custom_occurrence";
  }

  fields() {
    return {
      title: ""
    };
  }
}

export default new TransporterCustomOccurrence();
